import { Getters } from 'vuex-smart-module';
import NotificationsState from './state';

export default class NotificationsGetters extends Getters<NotificationsState> {}
